export function cloneValue(value) {
  if (typeof structuredClone === 'function') return structuredClone(value)
  return JSON.parse(JSON.stringify(value))
}

export function getAtPath(value, path, fallback = null) {
  const result = String(path || '')
    .split('.')
    .filter(Boolean)
    .reduce((cursor, key) => (cursor != null ? cursor[key] : undefined), value)

  return result === undefined ? fallback : result
}

export function setAtPath(value, path, nextValue) {
  const parts = String(path).split('.').filter(Boolean)
  if (!parts.length) return nextValue

  function update(current, index) {
    const part = parts[index]
    const copy = Array.isArray(current)
      ? [...current]
      : { ...(current && typeof current === 'object' ? current : {}) }
    if (index === parts.length - 1) {
      copy[part] = nextValue
      return copy
    }
    const child = current && typeof current === 'object' ? current[part] : null
    copy[part] = update(
      child || (/^\d+$/.test(parts[index + 1]) ? [] : {}),
      index + 1,
    )
    return copy
  }

  return update(value, 0)
}

export function mergeValues(base, patch) {
  const output = cloneValue(base)
  Object.entries(patch || {}).forEach(([key, value]) => {
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      output[key] &&
      typeof output[key] === 'object' &&
      !Array.isArray(output[key])
    ) {
      output[key] = mergeValues(output[key], value)
    } else {
      output[key] = cloneValue(value)
    }
  })
  return output
}
